export default __webpack_public_path__ + "static/Homepage-Graphic2-d4f9d60e201f3a00f5b19940a202720b.png";